import Vue from 'vue'
import Vuex from 'vuex' //引入 vuex
import base_data from '../config/data'
import http from '../config/http'
Vue.use(Vuex) //使用 vuex

export default new Vuex.Store({
  state: {
    // 初始化状态
    registration: JSON.parse(JSON.stringify(base_data)),
  },
  mutations: {
    // 处理状态
    reset(state) {
      Object.keys(base_data).forEach(key => {
        Object.keys(base_data[key]).forEach(key2 => {
          state.registration[key][key2] = base_data[key][key2]
        })
      })
    }
  },
  actions: {
      delImage({
                commit
            },payload) {
                return new Promise((resolve, reject) => {
                    console.log(commit)  
                    http.post('/case/image/del/',{'pk':payload.pk}).then(function(res) {
                            resolve(res);
                        })
                        .catch(function(err) {
                            reject(err);
                        });
                });
        },
    // 提交改变后的状态
  },
  getters: {
    //处理列表项
  },

})
